<template>
  <v-card
    style="border-radius: 10px"
    :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
  >
    <v-card-title>
      <span class="body-1 beez-bold pl-3">Tasks</span>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            :outline="$vuetify.dark"
            flat
            icon
            :loading="newViewMounting"
            @click.stop="changeView"
          >
            <v-icon>{{ newTaskUI ? 'table_chart' : 'view_agenda' }}</v-icon>
          </v-btn>
        </template>
        <span>{{ newTaskUI ? 'Table view' : 'Card view' }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          icon
          @click="hideInProgressTaskInput = !hideInProgressTaskInput"
        >
          <v-icon>{{
            hideInProgressTaskInput ? 'update' : 'update_disabled'
          }}</v-icon>
        </v-btn>
        <span>{{
          hideInProgressTaskInput
            ? 'Show Tasks In-progress'
            : 'Hide Tasks In-progress'
        }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          icon
          :outline="$vuetify.dark"
          :class="showFilter ? 'secondary' : ''"
          @click="showFilter = !showFilter"
        >
          <v-icon>filter_alt</v-icon>
        </v-btn>
        <span>Show Filter</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          icon
          :outline="$vuetify.dark"
          :class="showMetrics ? 'secondary' : ''"
          @click="showMetrics = !showMetrics"
        >
          <v-icon>insights</v-icon>
        </v-btn>
        <span>Show/Hide Metrics</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          icon
          :outline="$vuetify.dark"
          @click="showTime = !showTime"
        >
          <v-icon>{{ showTime ? 'today' : 'watch_later' }}</v-icon>
        </v-btn>
        <span>Toggle time with date</span>
      </v-tooltip>
    </v-card-title>
    <v-flex>
      <task-filter-card
        :task-view="taskView"
        :hide-in-progress-task-input="hideInProgressTaskInput"
        :refresh-flag="refreshFlag"
        class="mb-2"
        :show-filter="showFilter"
        :show-metrics="showMetrics"
        @filterUpdated="updateFilter"
      ></task-filter-card>
      <v-tabs fixed-tabs grow v-model="tab" slider-color="secondary">
        <v-tabs-slider color="secondary" />
        <v-tab :key="claimedTasks" v-if="can('TASK_CLAIMED')">
          <div class="beez-bold text-capitalize">Claimed User tasks</div>
        </v-tab>
        <v-tab :key="unclaimedTasks" v-if="can('TASK_GROUP')">
          <div class="beez-bold text-capitalize">Group User tasks</div>
        </v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="claimedTasks" v-if="can('TASK_CLAIMED')">
            <div v-if="newTaskUI">
              <task-list
                @view-mounted="viewChanged"
                :is-active="tab === claimedTasks"
                :show-time="showTime"
                :filter-obj="filterObj"
                task-view="claimed"
                :taskId="tab === claimedTasks ? taskId : ''"
                @refresh-kpi="refreshKPI"
              />
            </div>
            <div v-else>
              <tasks
                @view-mounted="viewChanged"
                :is-active="tab === claimedTasks"
                :show-time="showTime"
                :filter-obj="filterObj"
                task-type="claimed"
                :taskId="tab === claimedTasks ? taskId : ''"
                @refresh-kpi="refreshKPI"
              ></tasks>
            </div>
          </v-tab-item>
          <v-tab-item :key="unclaimedTasks" v-if="can('TASK_GROUP')">
            <div v-if="newTaskUI">
              <task-list
                @view-mounted="viewChanged"
                :is-active="tab === unclaimedTasks"
                :show-time="showTime"
                :filter-obj="filterObj"
                task-view="unclaimed"
                :taskId="tab === unclaimedTasks ? taskId : ''"
                @refresh-kpi="refreshKPI"
              />
            </div>
            <div v-else>
              <tasks
                @view-mounted="viewChanged"
                :is-active="tab === unclaimedTasks"
                :show-time="showTime"
                :filter-obj="filterObj"
                task-type="unclaimed"
                :taskId="tab === unclaimedTasks ? taskId : ''"
                @refresh-kpi="refreshKPI"
              ></tasks>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-flex>
  </v-card>
</template>

<script>
import TaskList from './TaskList'
import { mapGetters } from 'vuex'
import Tasks from '@/components/task-lists/Tasks'
import TaskFilterCard from '@/components/task-lists/TaskFilterCard'
import debounce from 'lodash/debounce'

export default {
  name: 'TaskListHome',
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  components: { Tasks, TaskList, TaskFilterCard },
  props: {},
  data() {
    return {
      showFilter: false,
      showTime: false,
      showMetrics: true,
      tab: 0,
      newViewMounting: false,
      refreshFlag: false,
      newTaskUI: true,
      filterObj: null,
      hideInProgressTaskInput: false,
      taskLoader: false,
      taskView: 'claimed',
      taskId: null,
      claimedTasks: 0,
      unclaimedTasks: 1
    }
  },
  watch: {
    tab() {
      if (this.tab === 0) {
        this.taskView = 'claimed'
      } else {
        this.taskView = 'unclaimed'
      }
    }
  },
  mounted() {
    if (this.$route.query.tab) {
      this.tab = parseInt(this.$route.query.tab)
    }
    if (this.$route.query.taskId) {
      this.taskId = this.$route.query.taskId
    }
  },
  methods: {
    refreshKPI() {
      let urlParams = null
      if (this.taskView === 'claimed') {
        this.$store.dispatch('fetchTasksCountByFormKey', urlParams)
      } else {
        this.$store.dispatch('fetchTasksCountByFormKeyByGroup', urlParams)
      }
    },
    changeView() {
      this.newViewMounting = true
      let fn = debounce(this.debounceChangeView, 100)
      fn()
    },
    debounceChangeView() {
      this.newTaskUI = !this.newTaskUI
    },
    viewChanged() {
      this.newViewMounting = false
    },
    updateFilter(filterObj) {
      this.filterObj = filterObj
      this.hideInProgressTaskInput = this.filterObj.hideInProgressTask
    }
  }
}
</script>

<style scoped></style>
